<template>
    <div>
        <div
                v-if="logLine.event === 'reminder-created' && !logLine.subject.resolved_at"
                class="btn-group"
                style="margin-top: -3px; margin-right: 10px"
        >
            <button type="button" class="btn btn-xs btn-black" data-toggle="dropdown">
                <i class="fa fa-cogs"></i> Functions <span class="caret"></span>
            </button>

            <ul class="dropdown-menu">
                <li>
                    <a href="#" @click.prevent="$emit('edit')">
                        <i class="fa fa-edit"></i> Edit
                    </a>
                </li>

              <li>
                <a href="#" @click.prevent="$emit('resolve')">
                  <i class="fa fa-check"></i> Resolve
                </a>
              </li>

              <li>
                <a href="#" @click.prevent="$emit('postpone')">
                  <i class="fa fa-clock"></i> Postpone
                </a>
              </li>
            </ul>
        </div>

        <log-line-user :log-line="logLine"></log-line-user>
    </div>
</template>

<script>
    import LogLineUser from '@/components/LogLine/LogLineUser'

    export default {
        components: {LogLineUser},

        props: {'logLine': {}}
    }
</script>
